import globalDefaults, { COLORS } from 'global/configs/theme/defaults'

export { COLORS }

export default {
  DESKTOP_WIDTH: 1184,
  DIALOGS_ZINDEX: globalDefaults.DIALOGS_ZINDEX
}
